import { FC, useEffect, useState } from 'react';

import { IconSupport } from 'src/components/Icons/Support';
import { UiButton } from 'src/components/UI/Button';
import { HelpCardModal } from 'src/components/Modals/HelpCardModal';
import { showAnyErrors } from 'src/utils/errors';
import { apiGetHelpCard } from 'src/api/helpcard';
import { HelpCardResponseType } from 'src/models/helpCard';

export const HeaderHelpComponent: FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [model, setModel] = useState<HelpCardResponseType | null>(null);

  useEffect(() => {
    apiGetHelpCard().then(setModel).catch(showAnyErrors);
  }, []);

  return (
    <li className="help">
      <UiButton tag="a" className="waves-effect link-like" onClick={() => setShowModal(true)} dataTest="questionIcon">
        <IconSupport />
      </UiButton>

      {showModal && <HelpCardModal onClose={() => setShowModal(false)} data={model} loading={!model} />}
    </li>
  );
};
